export default class Tree {
    constructor(){}
    insertInTree(node, rootNode) {
        if (node.parentCategoryId === null) {
            if(rootNode.children === null) {
                rootNode.children = [{
                    id: node.id,
                    image: [node.image],
                    isParent: node.isParent,
                    isHidden: node.isHidden,
                    shopCount: node.shopCount,
                    name: node.name,
                    logo: [node.logo],
                    parentCategoryId: node.parentCategoryId,
                    children: null
                }]
            } else {
                rootNode.children.push({
                    id: node.id,
                    isParent:  node.isParent,
                    shopCount: node.shopCount,
                    isHidden: node.isHidden,
                    name: node.name,
                    image: [node.image],
                    logo: [node.logo],
                    parentCategoryId: node.parentCategoryId,
                    children: null
                });
            }
        } else {
            const children = rootNode.children;
            for (let i = 0; i < children.length; i++) {
                const currentNode = children[i];
                if (currentNode.id === node.parentCategoryId) {
                    currentNode.children === null // =>
                    ? currentNode.children = [{
                        id: node.id,
                        isParent:  node.isParent,
                        shopCount: node.shopCount,
                        name: node.name,
                        isHidden: node.isHidden,
                        image: [node.image],
                        logo: [node.logo],
                        parentCategoryId: node.parentCategoryId,
                        children: null
                    }] // =>
                    : currentNode.children.push({
                        id: node.id,
                        image: [node.image],
                        isParent:  node.isParent,
                        shopCount: node.shopCount,
                        isHidden: node.isHidden,
                        name: node.name,
                        logo: [node.logo],
                        parentCategoryId: node.parentCategoryId,
                        children: null
                    });
                    return false;
                } else if (!!currentNode.children) {
                    this.insertInTree(node, currentNode);
                }
            }
        }
    }

    updateTree(node, rootNode){
        console.log(node)
        if (node.parentCategoryId === null) {
            rootNode.children.forEach((item) => {
                if (item.id === node.id){
                    console.log(item.isHidden, node.isHidden)
                    if(item.isHidden != node.isHidden) {
                        node.children = null
                    }
                    Object.assign(item, node);
                }
            });
        } else {
            const children = rootNode.children;
            for (let i = 0; i < children.length; i++) {
                const currentNode = children[i];
                if (currentNode.id === node.parentCategoryId){
                    currentNode.children.forEach((item) => {
                        if (item.id === node.id) {
                            console.log(item.isHidden, node.isHidden)
                            if(item.isHidden != node.isHidden) {
                                node.children = null
                            }
                            Object.assign(item, node);
                        }
                    });
                    return false;
                } else if (!!currentNode.children) {
                    this.updateTree(node, currentNode);
                }
            }
        }
    }
    
    // updateStoreCount(newShopCount, id, rootNode) {
    //     const children = rootNode.children;
    //     if (children) {
    //         children.forEach(currentNode => {
    //             if(currentNode.id == id){
    //                 currentNode.shopCount += newShopCount;
    //             } else {
    //                 this.printTree(currentNode);
    //             }
    //         });
    //     }
    // }

    printTree(node) {
        const children = node.children;
        if (children) {
            children.forEach(currentNode => {
                console.log(currentNode);
                this.printTree(currentNode);
            });
        }
    }
    deleteNode(id, node) {
        const children = node.children;
        if (children) {
            for (let i = 0; i < children.length; i++) {
                if (children[i].id !== id) {
                    this.deleteNode(id, children[i]);
                } else {
                    children.splice(i, 1);
                    return false;
                }
            }
        }
    }

    removeAllChildNodes(id, node) {
        const child = node.child;
        if (child) {
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < child.length; i++) {
                if (child[i].id !== id) {
                    this.removeAllChildNodes(id, child[i]);
                } else {
                    child[i].child = null;
                    return false;
                }
            }
        }
    }
}


